import React, { useState, useEffect } from "react";
import { backend } from "../../services/backend";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { userBackend } from "../../services";
import { UserPhoto } from "../../types";
import { handleOpenDatailPhoto } from "../../modals/functions";

const DocumentWatchForm = (props: { userId: number }) => {

    const docTitle = "Паспорт (лицевая сторона)";
    const State = useSelector((state: RootState) => state);
    const dispatch = useDispatch();
    const [documentFile, setDocumentFile] = useState<string>(
        ""
      );
    const [docFiles, setDocFiles] = useState<UserPhoto[]>([])
  
    const session = State.session;
    const { userId } = props;
  
    if (!session) {
      return null;
    }

    useEffect(() => {
      if (userId !== State.session?.id) {
        userBackend.getUserFiles(userId).then((res) => {
          setDocFiles(res.files.filter((file) => {
            return file.category === "document"
          }))
        })
      } else {
        setDocFiles(State.currentUserPhoto.filter((file) => {
          return file.category === "document"
        }))
      }
    }, []);

    const photoUrl = docFiles && docFiles[docFiles.length - 1]?.url.replace("uploads/", "/files/")

  return (
    <div className="form">
      <form>
        <div className="">
          <div className="inputRow">
            <label>
              {docTitle}
            </label>
            <div className="fileDisplayContainer" onClick={handleOpenDatailPhoto.bind(this, photoUrl, docTitle)}>
                <img src={photoUrl} />
            </div>
          </div>
          {/* <div className="inputRow">
            <label>
              Паспорт (лицевая сторона)
            </label>
            <div className="fileDisplayContainer">
                <img src="/images/document.png" />
            </div>
          </div> */}
        </div>
      </form>
    </div>
  );
};

export default DocumentWatchForm;
